import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import ListViewType from '@components/ListViewType';
import { toastError, toastSuccess } from '@components/Toast';

import AddPomFromRightPnael from '@features/pom/components/AddPomFromRightPnael';
import ImageSlider from '@features/pom/components/ImageSlider';
import PomCardView from '@features/pom/components/PomCardView';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import {
	addLibraryPOMInMeasurementTemplate,
	fetchMeasurementTemplateResponse,
	onDuplicatePom,
	removeLibraryPOMFromMeasurementTemplate
} from '@services/pomService';

import { checkUserType, getShortName, getUserInfo } from '@utils/Util';

const PomTagList = () => {
	const [pomTemplateDetails, setPomTemplateDetails] = useState(null);
	const [isOpen, setIsOpen] = useState(false);
	const [selectedViewType, setSelectedViewType] = useState(
		getUserInfo().systemPreference?.POM_TAG_LIST_VIEW_TYPE
	);
	const [selectedImage, setSelectedImage] = useState([]);
	const [selectedPomIds, setSelectedPomIds] = useState([]);

	const dispatch = useDispatch();
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		setSelectedPomIds(pomTemplateDetails?.LibraryPOMList?.map((item) => item?.id));
	}, [pomTemplateDetails]);

	useEffect(() => {
		onFetchMeasurementTemplateResponse();
	}, []);

	const onSetViewSetting = (selected) => {
		setSelectedViewType(selected);
	};

	const onFetchMeasurementTemplateResponse = async () => {
		try {
			dispatch(openLoader());
			const data = await fetchMeasurementTemplateResponse(id);
			setPomTemplateDetails(data);
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	const onDuplicatePomFromList = async (pomId) => {
		try {
			dispatch(openLoader());
			const data = await onDuplicatePom(pomTemplateDetails?.id, pomId);
			if (data?.success) {
				toastSuccess(data.message);
			}
			onFetchMeasurementTemplateResponse();
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	const onRemoveLibraryPOMFromMeasurementTemplate = async (pomId) => {
		try {
			dispatch(openLoader());
			const data = await removeLibraryPOMFromMeasurementTemplate(pomTemplateDetails?.id, pomId);
			if (data?.success) {
				toastSuccess(data.message);
			}
			onFetchMeasurementTemplateResponse();
			dispatch(closeLoader());
			return data;
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	const onCheckBoxClick = async (e) => {
		try {
			const pomId = parseInt(e.target.id);
			dispatch(openLoader());
			if (selectedPomIds?.includes(pomId)) {
				const data = await onRemoveLibraryPOMFromMeasurementTemplate(pomId);
				if (data?.success) {
					setSelectedPomIds(selectedPomIds?.filter((item) => item !== pomId));
				}
			} else {
				const data = await addLibraryPOMInMeasurementTemplate(pomTemplateDetails?.id, [pomId]);
				setSelectedPomIds([...selectedPomIds, data[0]?.id]);
				onFetchMeasurementTemplateResponse();
			}
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	const renderTableView = () => {
		return (
			<div className="data-table">
				<div className="compair-table">
					<table className="table with-border height-sm no-hover">
						<thead>
							<tr>
								<th>POM Visual</th>
								<th>Nitex POM Info</th>
								<th>Other Info</th>
								<th>How To Measure</th>
								<th>Tolerance</th>
							</tr>
						</thead>
						<tbody>
							{pomTemplateDetails?.LibraryPOMList?.map((item) => {
								const NITEX_DATA = item?.brandDetailsResponseList?.find(
									(item) => item?.brandResponse?.name === 'NITEX'
								);
								return (
									<tr key={item?.id}>
										<td className="visual-td" rowSpan={1}>
											<ImageSlider
												type="TABLE_VIEW"
												imageList={item?.visualResponseList}
												item={item}
												selectedImage={selectedImage}
												setSelectedImage={setSelectedImage}
											/>
										</td>
										<td className="pom-code">
											<p className="medium-14 weight-500 gray_dark_01">
												{NITEX_DATA?.pomCode}
											</p>
											<p className="regular-12">{NITEX_DATA?.pomName}</p>
											<div className="edit-items">
												<div className="option">
													<div className="dropdown">
														<button
															className="btn btn-default dropdown-toggle"
															type="button"
															id="menu1"
															data-toggle="dropdown"
															aria-expanded="false"
														>
															<img
																src={`${process.env.PUBLIC_URL}/icons/more_vertical.svg`}
																alt="tee"
															/>
														</button>
														<ul
															className="dropdown-menu dropdown-menu-right shadow-lg"
															role="menu"
															aria-labelledby="menu1"
															x-placement="bottom-end"
														>
															<li
																role="presentation"
																className="px-4 pb-3 pt-3"
																onClick={() =>
																	onDuplicatePomFromList(item?.id)
																}
															>
																<span
																	role="menuitem"
																	className="font-weight-normal text-black"
																>
																	Duplicate
																</span>
															</li>
															<li
																role="presentation"
																className="px-4 pb-3"
																onClick={() =>
																	onRemoveLibraryPOMFromMeasurementTemplate(
																		item?.id
																	)
																}
															>
																<span
																	role="menuitem"
																	className="font-weight-normal red"
																>
																	Remove
																</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</td>
										<td className="other-info" rowSpan={1}>
											<p className="d-block regular-14 gray_dark_02">
												Category:{' '}
												<Tooltip
													title={
														<span className="regular-12">
															{item?.allCategory
																? 'All'
																: item?.subCategoryResponseList
																		?.map((category) => category?.name)
																		.join(', ')}
														</span>
													}
													placement="top"
													arrow
												>
													<span className="gray_dark_01 pl-2">
														{item?.allCategory
															? 'All'
															: getShortName(
																	item?.subCategoryResponseList
																		?.map((category) => category?.name)
																		.join(', '),
																	20
																)}
													</span>
												</Tooltip>
											</p>
											<p className="d-block regular-14 gray_dark_02">
												Market:{' '}
												<Tooltip
													title={
														<span className="regular-12">
															{item?.allMarket
																? 'All'
																: item?.marketList
																		?.map((market) => market?.name)
																		.join(', ')}
														</span>
													}
													placement="top"
													arrow
												>
													<span className="gray_dark_01 pl-2">
														{item?.allMarket
															? 'All'
															: getShortName(
																	item?.marketList
																		?.map((market) => market?.name)
																		.join(', '),
																	20
																)}
													</span>
												</Tooltip>
											</p>

											<p className="d-block regular-14 gray_dark_02">
												TBO:{' '}
												<span className="gray_dark_01 pl-2">
													{item?.parentCategory?.name}
												</span>
											</p>
											<p className="d-block regular-14 gray_dark_02">
												Position:{' '}
												<span className="gray_dark_01 pl-2">
													{item?.position?.name}
												</span>
											</p>
											<p className="d-block regular-14 gray_dark_02">
												Serial:{' '}
												<span className="gray_dark_01 pl-2">{item?.serial}</span>
											</p>
											<p className="d-block regular-14 gray_dark_02">
												POM Size:{' '}
												<span className="gray_dark_01 pl-2">{item?.size?.name}</span>
											</p>
											<p className="d-block regular-14 gray_dark_02">
												Side:{' '}
												<span className="gray_dark_01 pl-2">{item?.side?.name}</span>
											</p>
										</td>
										<td>
											<p>{NITEX_DATA?.howToMeasure}</p>
										</td>
										<td> {NITEX_DATA?.tolerance ? NITEX_DATA.tolerance + ' CM' : ''}</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
			</div>
		);
	};

	const renderPomList = () => {
		return selectedViewType === 'NARROW_VIEW' ? (
			<PomCardView
				pomList={pomTemplateDetails?.LibraryPOMList}
				onDeletePomFromList={onRemoveLibraryPOMFromMeasurementTemplate}
				selectedBrand={[]}
			/>
		) : (
			renderTableView()
		);
	};

	return (
		<>
			<div className="top-header ">
				{/* Filter Contanier top*/}
				<div className="page-title-area pb-2 d-flex align-items-center">
					<button
						className="button text size32 p-0"
						onClick={() => navigate('/configuration/measurement-template')}
					>
						<img src={`${process.env.PUBLIC_URL}/icons/left-arrwo-dark.svg`} alt="back" />
					</button>
					<h1 className="semibold-16">{pomTemplateDetails?.subCategoryResponse?.name}</h1>
				</div>
				<div className="filter-container-top filter-container-top-v2 transparent-bg">
					<div className="filters">
						<div className="chip-container">
							<span className="regular-14 weight-500 gray_dark_02">
								{pomTemplateDetails?.LibraryPOMList?.length} items
							</span>
						</div>
					</div>
					{/*Filter Actions*/}
					<div className="filter-actions compare-filter-actions">
						<ListViewType
							type="POM_TAG_LIST"
							onSelectType={(selected) => onSetViewSetting(selected)}
						/>
						{checkUserType('ADMIN') && (
							<div className="add-new-design">
								<button className="button text size32 px-0" onClick={() => setIsOpen(true)}>
									<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
									<span className="ml-1">Add POM</span>
								</button>
							</div>
						)}
					</div>
				</div>
			</div>

			{pomTemplateDetails?.LibraryPOMList?.length > 0 && (
				<section className="filter-data-container filter-v3-data-container">
					{' '}
					<div className="data-table">{renderPomList()}</div>
				</section>
			)}

			{/* Filter Data container */}
			{pomTemplateDetails?.LibraryPOMList?.length === 0 && checkUserType('ADMIN') && (
				<div className="data-table">
					<div className="pom-empty d-flex justify-content-center align-items-center flex-column">
						<p className="medium-16 gray_dark_03">No POM found</p>
						<button className="button size32 outline" onClick={() => setIsOpen(true)}>
							<img src={`${process.env.PUBLIC_URL}/icons/add_primary.svg`} alt />
							<span className="ml-1 regular-12 gray_dark_01">Add POM</span>
						</button>
					</div>
				</div>
			)}
			{isOpen && (
				<AddPomFromRightPnael
					selectedPomIds={selectedPomIds}
					onCheckBoxClick={onCheckBoxClick}
					pomTemplateDetails={pomTemplateDetails}
					onClose={() => setIsOpen(false)}
					onAddSuccess={(data) =>
						setPomTemplateDetails({ ...pomTemplateDetails, LibraryPOMList: data })
					}
					fromPage="POM_TAG_LIST"
				/>
			)}
		</>
	);
};

export default PomTagList;
